import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";
import Uppy from "@uppy/core";
// import FileInput from "@uppy/file-input";
import ThumbnailGenerator from "@uppy/thumbnail-generator";

// import "@uppy/core/dist/style.min.css";

export default class extends Controller {
  static targets = [
    "image",
    "inputFile",
    "inputHiddenSignedBlob",
    "plus",
    "progress",
    "progressBar",
    "video",
  ];

  static values = {
    types: { type: Array, default: ["image/*", "video/*"] }, // "application/pdf"
    maxFileSize: { type: Number, default: 500 * 1024 * 1024 },
    openFileInput: { type: Boolean, default: false },
  };

  connect() {
    super.connect();
    console.log(
      "uppy_controller connected types, maxFileSize",
      this.typesValue,
      this.maxFileSizeValue,
    );

    this.uppy = new Uppy({
      id: true,
      debug: true,
      autoProceed: false,
      restrictions: {
        maxNumberOfFiles: 1,
        maxFileSize: this.maxFileSizeValue,
        allowedFileTypes: this.typesValue,
      },
    }).use(ThumbnailGenerator, {
      thumbnailWidth: 365,
    });

    // Store object URLs for cleanup
    this.objectURLs = [];

    console.log("this.uppy", this.uppy);

    // Manual file input handling as backup
    this.handleFileChange = (event) => {
      console.log("file input change detected", event, event.target.files);
      const files = Array.from(event.target.files);
      console.log("Manual file input change detected:", files);
      console.log("File input element:", event.target);
      console.log("Number of files selected:", files.length);

      if (files.length === 0) {
        console.log("No files selected");
        return;
      }

      files.forEach((file, index) => {
        console.log(`Processing file ${index + 1}:`, {
          name: file.name,
          type: file.type,
          size: file.size,
        });

        try {
          this.uppy.addFile({
            name: file.name,
            type: file.type,
            data: file,
            source: "file input",
            isRemote: false,
          });
          console.log(`Successfully added file ${index + 1} to Uppy`);
        } catch (err) {
          console.error(`Error adding file ${index + 1} to Uppy:`, err);
        }
      });
    };

    this.inputFileTarget.addEventListener("change", this.handleFileChange);

    this.uppy.on("thumbnail:generated", (file, preview) => {
      console.log("thumbnail generated", file, preview);
      this.imageTarget.src = preview;
      this.imageTarget.classList.remove("hidden");
      this.plusTarget.classList.add("hidden");
    });

    this.uppy.on("file-added", (file) => {
      console.log("🎉 FILE ADDED EVENT TRIGGERED!", file);
      console.log("File details:", {
        id: file.id,
        name: file.name,
        type: file.type,
        size: file.size,
      });

      // Handle video preview
      if (file.type.startsWith("video/")) {
        console.log("Video file detected, creating preview");
        const videoURL = URL.createObjectURL(file.data);
        this.objectURLs.push(videoURL);

        // Hide image and plus, show video
        if (this.hasImageTarget) {
          this.imageTarget.classList.add("hidden");
        }
        if (this.hasVideoTarget) {
          this.videoTarget.src = videoURL;
          this.videoTarget.classList.remove("hidden");
        }
        if (this.hasPlusTarget) {
          this.plusTarget.classList.add("hidden");
        }
      }

      this.showProgressBar();

      this.directUpload = new DirectUpload(
        file.data,
        "/rails/active_storage/direct_uploads",
        this,
      );
      this.directUpload.create((error, blob) => {
        this.hideProgressBar();

        if (error) {
          this.directUpload = null;
          console.error("Uppy directUpload error:", error);
        } else {
          console.log("Uppy directUpload success:", blob);
          if (this.hasInputHiddenSignedBlobTarget) {
            this.inputHiddenSignedBlobTarget.value = blob.signed_id;
            console.log("Set hidden field value to:", blob.signed_id);
          } else {
            console.warn("No inputHiddenSignedBlobTarget found");
          }
        }
      });
    });

    this.uppy.on("upload-success", (file, response) => {
      console.log("upload-success", file, response);
    });

    this.uppy.on("error", (error) => {
      console.error("error", error.stack);
    });

    this.uppy.on("upload-error", (file, error, response) => {
      console.log("upload-error", file, error, response);
    });

    this.uppy.on("restriction-failed", (file, error) => {
      console.log("restriction-failed", file, error);
    });

    if (this.openFileInputValue) {
      this.inputFileTarget.click();
    }
  }

  disconnect() {
    console.log("uppy disconnect");
    if (this.inputFileTarget) {
      this.inputFileTarget.removeEventListener("change", this.handleFileChange);
    }

    // Clean up object URLs to prevent memory leaks
    this.objectURLs.forEach((url) => URL.revokeObjectURL(url));
    this.objectURLs = [];

    this.uppy.destroy();
  }

  selectFile(event) {
    event.preventDefault();
    console.log("selectFile clicked, input element:", this.inputFileTarget);
    this.inputFileTarget.click();
  }

  // ==========

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", (event) =>
      this.directUploadDidProgress(event),
    );
  }

  directUploadDidProgress(event) {
    console.log("==> progress", event.loaded, event.total);
    // Use event.loaded and event.total to update the progress bar
    if (this.hasProgressTarget) {
      this.progressTarget.style.width = `${(event.loaded / event.total) * 100}%`;
    }
  }

  // ==========

  hideProgressBar() {
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.classList.add("hidden");
    }
    if (this.hasProgressTarget) {
      this.progressTarget.style.width = `0%`;
    }
  }

  showProgressBar() {
    if (this.hasProgressTarget) {
      this.progressTarget.style.width = `0%`;
    }
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.classList.remove("hidden");
    }
  }
}
